import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TippyDirective } from '@ngneat/helipopper';
import { ConditionBuilderModule } from '@ee/common/condition-builder';
import { DocumentGenerationControlComponent } from './document-generation-control.component';
import { DocumentRuleDialogComponent } from './document-rule-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    TippyDirective,
    ConditionBuilderModule
  ],
  declarations: [DocumentGenerationControlComponent, DocumentRuleDialogComponent],
  exports: [DocumentGenerationControlComponent]
})
export class DocumentGenerationControlModule {}
